(function () {
	'use strict';

	theme.juhlaMenu = {
		elements: {
			juhlamenuHeader: document.getElementById('juhlamenu-header'),
			headerInput: document.getElementById('header-input-field'),
			headerButton: document.getElementById('header-input-button'),
		},
		init: function () {
			var collectionTriggers = document.getElementsByClassName('collapsible-trigger');
			[...collectionTriggers].forEach((trigger) => {
				var opened = false;
				trigger.addEventListener('click', function () {
					var openedText = this.querySelector('#open-close');
					if (opened == true) {
						openedText.innerHTML = 'Näytä ';
						opened = false;
					} else {
						openedText.innerHTML = 'Sulje ';
						opened = true;
					}
				});
			});

			var collectionClosers = document.getElementsByClassName('collection-closer');
			console.log(collectionClosers, 'collectionClosers');
			var collectionContent = document.getElementsByClassName('collapsible-content collapsible-content--all');
			console.log(collectionContent, 'Collection Content');

			[...collectionClosers].forEach((trigger) => {
				trigger.addEventListener('click', function () {
					//var openedText = this.querySelector('#open-close');
					var id = this.id.replace('jm-collection-btn-', '');
					console.log(id);
					document.getElementById('juhlamenu-collection-btn-' + id).classList.remove('is-open');
					document.getElementById('FAQ-content-' + id).classList.remove('is-open');
					document.getElementById('FAQ-content-' + id).style.height = '0px';

					//collectionContent.classList.remove('is-open');
				});
			});

			var atcButtons = document.querySelectorAll('button.add-to-juhlamenu');
			var gridItemQuantity = document.querySelectorAll('input.eater-input');

			theme.juhlaMenu.elements.headerInput.addEventListener('focusout', function () {
				var val = parseInt(this.value);
				var max = parseInt(this.getAttribute('max'));
				var min = parseInt(this.getAttribute('min'));

				if (val > max) {
					this.value = max;
				} else if (val < min) {
					this.value = min;
				}
			});
			theme.juhlaMenu.elements.headerInput.addEventListener('keyup', function () {
				var val = parseInt(this.value);
				var max = parseInt(this.getAttribute('max'));
				var min = parseInt(this.getAttribute('min'));
				if (val > max) {
					this.value = max;
				}
			});
			theme.juhlaMenu.elements.headerButton.addEventListener('click', function (e) {
				e.preventDefault();
				var headerInputValue = theme.juhlaMenu.elements.headerInput.value;
				[...gridItemQuantity].forEach((input) => {
					input.value = headerInputValue;
				});
			});

			[...atcButtons].forEach((button) => {
				button.addEventListener('click', function (e) {
					e.preventDefault();
					var productHandle = this.getAttribute('data-product-handle');

					if (
						button.classList.contains('is-coldchain-product') &&
						!theme.coldChain.validatePostalCode(theme.coldChain.currentPostalCode)
					) {
						alert(
							theme.strings.juhlamenuNotification
						);
						return false;
					}

					var eaterCount = button.parentElement.parentElement.querySelector('.eater-input').value;
					var eaterCountString = eaterCount + ' ' + 'hlö';
					var servingDataInput = button.parentElement.querySelector('input');
					button.classList.add('btn--loading');
					if (eaterCount == 0) {
						return;
					}

					fetch('/products/' + productHandle + '.js')
						.then(function (response) {
							return response.json();
						})
						.then(function (product) {
							var smallestWeight = Number(servingDataInput.getAttribute('data-weight-for-serving'));
							var largestWeight = 0;
							var priceDivider = Number(servingDataInput.getAttribute('data-per-serving-divider'));
							var colDivider = Number(servingDataInput.getAttribute('data-col-serving-divider'));
							var smallestVariant;
							var largestVariant;
							var oneServingWeight = Number(servingDataInput.getAttribute('data-per-serving-weight'));
							var colServingSize = Number(servingDataInput.getAttribute('data-col-serving-size'));

							// If has collection-specific custom serving size, use that as divider to cal price
							if (colServingSize) {
								// console.log('Is custom serving size');
								oneServingWeight = colServingSize;
								priceDivider = colDivider;
							}

							// Loop through variants options to get
							[...product.variants].forEach((variant) => {
								var variant_option = variant.title.split(' ');
								var weight = Number(variant_option[0].replace(',', '.'));
								var unit = variant_option[1];

								if (unit == 'kg') {
									weight = weight * 1000;
								}
								if (weight > smallestWeight && weight > largestWeight) {
									largestWeight = weight;
									largestVariant = variant;
								} else if (weight <= smallestWeight) {
									smallestVariant = variant;
								}
							});

							var largeVariantsToAdd = 0;
							var smallVariantsToAdd = 0;
							var eaters_left_to_fulfill = 0;
							var onlyBigs = false;
							var onlySmall = false;
							var isMixed = false;

							if (largestWeight > 0) {
								if (eaterCount / (largestWeight / oneServingWeight) >= 1) {
									/*
									console.log('++++++++');
									console.log(Math.round(eaterCount / (largestWeight / oneServingWeight)));
									console.log(Math.ceil(eaterCount / (largestWeight / oneServingWeight)));
									console.log(eaterCount / (largestWeight / oneServingWeight));
									console.log('++++++++');
									*/

									if (eaterCount >= 30) {
										largeVariantsToAdd = Math.floor(eaterCount / (largestWeight / oneServingWeight));
										console.log(eaterCount / (largestWeight / oneServingWeight));
									} else {
										// HUOMIO SAATTAA MENNÄ NYKYISELLÄÄN RIKKI -> FIX MUUTA TÄMÄ Math.ceil(); ja korjaa muualta.
										largeVariantsToAdd = Math.floor(eaterCount / (largestWeight / oneServingWeight));
									}

									eaters_left_to_fulfill = eaterCount - (largestWeight * largeVariantsToAdd) / oneServingWeight;
									/*
									console.log('FIRST IF LARGE TO ADD == ' + largeVariantsToAdd);
									console.log('FIRST IF EATERS LEFT == ' + eaters_left_to_fulfill);
									*/
									if (eaters_left_to_fulfill == 0) {
										onlyBigs = true;
										/*
										console.log('ONLY BIGS == TRUE');
										console.log('ONLY BIGS == large to add == ' + largeVariantsToAdd);
										console.log('ONLY BIGS == eaters left == ' + eaters_left_to_fulfill);
										*/
									}
									// Tsekataan onko tasaluku isoista
									else if (Number.isInteger(eaterCount / (largestWeight / oneServingWeight))) {
										onlyBigs = true;
										/*
										console.log('TÄÄLLÄ OLLAAN JA VAAN ISOJA LISÄTÄÄN');
										*/
									} else {
										isMixed = true;
										/*
										console.log('IS MIXD == TRUE');
										console.log('IS MIXD == large to add == ' + largeVariantsToAdd);
										console.log('IS MIXD == eaters left == ' + eaters_left_to_fulfill);
										*/
									}
								} else {
									onlySmall = true;
								}
								//console.log(eaterCount);
								//console.log(largestWeight);
								//console.log(oneServingWeight);
								//console.log("larges to add " + largeVariantsToAdd);
							}
							if (isMixed == true) {
								//console.log("IS MIXED");
								// lisätään myös pieniä
								// otetaan ylhäätlä eaters left to fullfill ja jatketaan pieniin
							} else if (onlySmall == true) {
								//console.log("ONLY SMALL");
								eaters_left_to_fulfill = eaterCount;
							} else if (onlyBigs == false && eaters_left_to_fulfill != 0) {
								//console.log("ONLY BIGS");
								eaters_left_to_fulfill = eaterCount;
							} else if (onlyBigs == true) {
								eaters_left_to_fulfill = 0;
							} else {
								eaters_left_to_fulfill = eaterCount;
							}
							//console.log("left to ful " + eaters_left_to_fulfill);
							//console.log("smalltoADD = " + eaters_left_to_fulfill / priceDivider);
							smallVariantsToAdd = Math.ceil(eaters_left_to_fulfill / priceDivider);
							//console.log("small to add " + smallVariantsToAdd);
							var itemsToAdd = { items: [] };
							if (largeVariantsToAdd > 0) {
								var eaterCount_large = eaterCountString.split(' ');
								eaterCount_large[0] = Math.round(largeVariantsToAdd * (largestWeight / oneServingWeight));
								// console.dir(eaterCount_large);
								let itemPrice =
									((largeVariantsToAdd * largestWeight) / parseInt(product.variants[0].weight)) *
									(parseInt(product.variants[0].price) / 100);
								let itemTotal = largestWeight;
								if (product && product.hasOwnProperty('variants')) {
									product.variants.forEach((item) => {
										if (itemTotal == item.weight) {
											itemPrice = parseInt(item.price) / 100;
											itemPrice *= largeVariantsToAdd;
										}
									});
								}
								itemsToAdd.items.push({
									id: largestVariant.id,
									data: largestVariant,
									product: product,
									quantity: largeVariantsToAdd,
									properties: {
										price: itemPrice.toFixed(2),
										totalWeight: ((largeVariantsToAdd * largestWeight) / 1000).toFixed(1) + ' kg',
										subWeight: (largestWeight / 1000).toFixed(1) + ' kg',
										people: eaterCount_large.join(' '),
										peopleCount: eaterCount_large[0],
										_Group: product.handle,
									},
								});
							}

							if (smallVariantsToAdd > 0) {
								/*
								console.log('----------');
								console.log(eaters_left_to_fulfill);
								console.log('test ' + smallVariantsToAdd * (smallestWeight / oneServingWeight));
								*/
								var eaterCount_small = eaterCountString.split(' ');
								eaterCount_small[0] = Math.round(smallVariantsToAdd * (smallestWeight / oneServingWeight));
								let itemPrice =
									((smallVariantsToAdd * smallestWeight) / parseInt(product.variants[0].weight)) *
									(parseInt(product.variants[0].price) / 100);
								let itemTotal = smallVariantsToAdd * smallestWeight;
								if (product && product.hasOwnProperty('variants')) {
									product.variants.forEach((item) => {
										if (itemTotal == item.weight) {
											itemPrice = parseInt(item.price) / 100;
										}
									});
								}
								itemsToAdd.items.push({
									id: smallestVariant.id,
									data: smallestVariant,
									product: product,
									quantity: smallVariantsToAdd,
									properties: {
										price: itemPrice.toFixed(2),
										totalWeight: ((smallVariantsToAdd * smallestWeight) / 1000).toFixed(1) + ' kg',
										subWeight: (smallestWeight / 1000).toFixed(1) + ' kg',
										people: eaterCount_small.join(' '),
										peopleCount: eaterCount_small[0],
										_Group: product.handle,
									},
								});
							}
							/*
							console.log('products', product);
							console.log('itemsAdded', itemsToAdd);
							*/
							if (smallVariantsToAdd == 0 && largeVariantsToAdd == 0) {
								let itemPrice =
									((1 * smallestWeight) / parseInt(product.variants[0].weight)) *
									(parseInt(product.variants[0].price) / 100);
								let itemTotal = 1 * smallestWeight;
								if (product && product.hasOwnProperty('variants')) {
									product.variants.forEach((item) => {
										if (itemTotal == item.weight) {
											itemPrice = parseInt(item.price) / 100;
										}
									});
								}
								itemsToAdd.items.push({
									id: product.variants[0].id,
									data: product.variants[0],
									product: product,
									quantity: 1,
									properties: {
										price: itemPrice.toFixed(2),
										totalWeight: ((1 * smallestWeight) / 1000).toFixed(1) + ' kg',
										subWeight: ((1 * smallestWeight) / 1000).toFixed(1) + ' kg',
										people: eaterCount,
										peopleCount: eaterCount,
										_Group: product.handle,
									},
								});
							}

							var listItem = document.getElementById('jm-selected-items');
							for (var i = 0; i < 1; i++) {
								var lineTotalPrice = 0.0;
								var lineTotalPeople = 0;
								var lineTotalWeight = 0;
								for (var j = 0; j < itemsToAdd.items.length; j++) {
									lineTotalPrice += parseFloat(itemsToAdd.items[j].properties.price);
									lineTotalPeople += parseInt(itemsToAdd.items[j].properties.peopleCount);
									lineTotalWeight += parseFloat(itemsToAdd.items[j].properties.totalWeight);
								}
								var productItem = itemsToAdd.items[i];
								/*
								console.log(itemsToAdd, 'product item');
								*/
								if (document.getElementById('jm-' + productItem.product.id)) {
									var itemElem = document.getElementById('jm-' + productItem.product.id);
									itemElem.parentNode.removeChild(itemElem);
								}

								var divElemnt = document.createElement('div');
								divElemnt.setAttribute('id', 'jm-' + productItem.product.id);
								var htmldata = "<div class='jm-item'>";
								htmldata += "<div class='jm-header'>";
								htmldata += '<span class="jm-product-title">' + productItem.product.title + '</span>';
								htmldata +=
									'<span class="jm-product-ppl" id="jm-ppl-' +
									productItem.product.id +
									'">' +
									lineTotalPeople +
									' hlö</span>';
								htmldata +=
									'<span class="jm-product-weight jm-p-w" id="jm-wth-' +
									productItem.product.id +
									'">' +
									lineTotalWeight.toFixed(2).toString().replace('.', ',') +
									' kg</span>';
								htmldata +=
									'<span id="jm-prc-' +
									productItem.product.id +
									'" class="jm-product-weight jm-p-p">' +
									lineTotalPrice.toFixed(2).toString().replace('.', ',') +
									' &euro;</span>';
								htmldata += '</div>';
								htmldata += '</div>';

								htmldata += "<div id='jm-image-item' class='jm-image-item'>";
								htmldata += "<div class='jm-image'><img src='" + productItem.product.featured_image + "'/></div>";
								for (var j = 0; j < itemsToAdd.items.length; j++) {
									var subItem = itemsToAdd.items[j];
									/*
									console.log(subItem.data.option1, 'subItem.data.option1');
									*/
									htmldata +=
										"<div class='jm-item-qty' variant-id='" +
										subItem.id +
										"'><button href='javascript:void 0' class='jm-remove-item' onclick='removeItem(" +
										productItem.product.id +
										',' +
										lineTotalPeople +
										',' +
										subItem.properties.peopleCount +
										")'>x</button>";
									htmldata +=
										"<div class='jm-info-container'><label  data='" +
										subItem.properties.peopleCount +
										"' style='margin-bottom: 0px;' class='jm-cl-ppl-" +
										productItem.product.id +
										"' id='jm-ppl-" +
										subItem.id +
										"'>" +
										subItem.properties.people +
										"</label><span data='" +
										subItem.properties.totalWeight +
										"' class='jm-item-ppl jm-cl-weight-" +
										productItem.product.id +
										"' id='jm-wtgh-" +
										subItem.id +
										"'>" +
										subItem.quantity +
										' x ' +
										subItem.properties.subWeight.replace('.', ',') +
										'</span><label data="' +
										subItem.properties.price +
										'" class="jm-cl-price jm-cl-prc-' +
										productItem.product.id +
										'" id="jm-price-' +
										subItem.id +
										'">' +
										subItem.properties.price.toString().replace('.', ',') +
										' &euro;</label>';
									htmldata +=
										"<div class='input--box'><div class='qty'><button class='jm-minus-btn' onclick='minusQty(" +
										subItem.id +
										',' +
										productItem.product.id +
										")'>-</button><input disabled type='text' class='jm-qty-input' type='text' id='jm-sb-qty-" +
										subItem.id +
										"' 		dfqty='" +
										subItem.quantity +
										"'	dfppl='" +
										subItem.properties.peopleCount +
										"'			dfprc='" +
										subItem.properties.price +
										"'		dfwgth='" +
										subItem.properties.totalWeight +
										"' dfsubwgth='" +
										subItem.properties.subWeight +
										"'					value='" +
										subItem.quantity +
										"' data-default='" +
										subItem.quantity +
										"'/><button class='jm-plus-btn' onclick='plusQty(" +
										subItem.id +
										',' +
										productItem.product.id +
										")'>+</button></div>";
									htmldata += '</div>';
									htmldata += '</div>';
									htmldata += '</div>';
								}
								htmldata += '</div>';
								htmldata += '</div>';
								divElemnt.innerHTML = htmldata;
								listItem.appendChild(divElemnt);
							}
							button.classList.remove('btn--loading');
							calCulateTotal();
						})
						.catch(function (ex) {
							console.log('parsing failed', ex);
						});
				});
			});
			// init end
		},
	};
	theme.juhlaMenu.init();
})();
// Removes line item
function removeItem(id, total, subTotal) {
	var remaining = parseInt(total) - parseInt(subTotal);
	if (remaining > 0) {
		document.getElementById('qty-input-' + id).value = remaining;
		document.getElementById('add-btn-' + id).click();
	} else {
		var item = document.getElementById('jm-' + id);
		if (item) {
			item.parentNode.removeChild(item);
		}
		calCulateTotal();
	}
}
// Increment Qty
function plusQty(id, pid) {
	var obj = document.getElementById('jm-sb-qty-' + id);
	var newVal = parseInt(obj.getAttribute('data-default')) + 1;
	obj.value = newVal;
	obj.setAttribute('data-default', newVal);
	ItemCalculation(id, newVal, pid);
}
// Decrement Qty
function minusQty(id, pid) {
	var obj = document.getElementById('jm-sb-qty-' + id);
	var newVal = parseInt(obj.getAttribute('data-default')) - 1;
	if (newVal > 0) {
		obj.value = newVal;
		obj.setAttribute('data-default', newVal);
		ItemCalculation(id, newVal, pid);
	}
}
function ItemCalculation(id, newqty, pid) {
	var obj = document.getElementById('jm-sb-qty-' + id);
	var qty = parseInt(obj.getAttribute('dfqty'));
	var wth = ((parseFloat(obj.getAttribute('dfwgth')).toFixed(1) / qty) * newqty).toFixed(1);
	var price = ((parseFloat(obj.getAttribute('dfprc')).toFixed(2) / qty) * newqty).toFixed(2);
	var ppl = parseInt(((parseFloat(obj.getAttribute('dfppl')).toFixed(2) / qty) * newqty).toFixed(2));
	//alert(wth + '-' + price + '- ' + ppl);
	document.getElementById('jm-wtgh-' + id).innerHTML =
		newqty + ' x ' + obj.getAttribute('dfsubwgth').toString().replace('.', ',');
	//document.getElementById('jm-newqty-' + id).innerHTML = newqty;
	document.getElementById('jm-wtgh-' + id).setAttribute('data', wth);
	document.getElementById('jm-price-' + id).innerHTML = price.toString().replace('.', ',') + ' &euro;';
	document.getElementById('jm-price-' + id).setAttribute('data', price);
	document.getElementById('jm-ppl-' + id).innerHTML = ppl + ' hlö';
	document.getElementById('jm-ppl-' + id).setAttribute('data', ppl);
	var weightItems = document.querySelectorAll('.jm-cl-weight-' + pid);
	// console.log(weightItems, 'weightItems');
	var totalWeight = 0;
	for (var i = 0; i < weightItems.length; i++) {
		totalWeight += parseFloat(weightItems[i].getAttribute('data'));
	}
	document.getElementById('jm-wth-' + pid).innerHTML = totalWeight.toFixed(1).toString().replace('.', ',') + ' kg';

	var pplItems = document.querySelectorAll('.jm-cl-ppl-' + pid);
	var totalPpl = 0;
	for (var i = 0; i < pplItems.length; i++) {
		totalPpl += parseFloat(pplItems[i].getAttribute('data'));
	}
	document.getElementById('jm-ppl-' + pid).innerHTML = parseInt(totalPpl) + ' hlö';

	var prcItems = document.querySelectorAll('.jm-cl-prc-' + pid);
	var totalPrc = 0;
	for (var i = 0; i < prcItems.length; i++) {
		totalPrc += parseFloat(prcItems[i].getAttribute('data'));
	}
	document.getElementById('jm-prc-' + pid).innerHTML = totalPrc.toFixed(2).toString().replace('.', ',') + ' &euro;';
	calCulateTotal();
}
// Calculate Total Weight and Price
function calCulateTotal() {
	var totalWeight = 0;
	var weightItem = document.querySelectorAll('.jm-p-w');
	for (var i = 0; i < weightItem.length; i++) {
		totalWeight += parseFloat(weightItem[i].innerHTML.replace(',', '.'));
	}
	var totalPrice = 0;
	var priceItem = document.querySelectorAll('.jm-p-p');
	for (var i = 0; i < priceItem.length; i++) {
		totalPrice += parseFloat(priceItem[i].innerHTML.replace(',', '.'));
	}
	document.getElementById('jmc-total').innerHTML = totalPrice.toFixed(2).toString().replace('.', ',') + ' &euro;';
	document.getElementById('jmc-floating-total-price').innerHTML =
		totalPrice.toFixed(2).toString().replace('.', ',') + ' &euro;';
	document.getElementById('jmc-total-weight').innerHTML = totalWeight.toFixed(1).toString().replace('.', ',') + ' kg';
	document.getElementById('jmc-floating-total-weight').innerHTML =
		totalWeight.toFixed(1).toString().replace('.', ',') + ' kg';
}
// Post to Cart
function manualAddToCart() {
	let data = { items: [] };
	var cartItems = document.querySelectorAll('.jm-item-qty');
	for (var i = 0; i < cartItems.length; i++) {
		var id = cartItems[i].getAttribute('variant-id');
		var qty = parseInt(document.getElementById('jm-sb-qty-' + id).value);
		data.items.push({ id: id, quantity: qty });
	}
	// console.log('data', data);
	fetch('/cart/add.js', {
		method: 'POST',
		body: JSON.stringify(data),
		credentials: 'same-origin',
		headers: {
			'Content-Type': 'application/json',
			'X-Requested-With': 'XMLHttpRequest',
		},
	})
		.then((response) => response.json())
		.then(function (data) {
			// console.log(data.status);
			if (data.status === 422) {
				console.log('error', data);
			} else {
				window.location = '/cart';
			}
		});
}
// Show and hide extra info in mobile view
function showAdditionalInfo() {
	var togglelink = document.getElementById('jm-extra-info');
	var extrainfos = document.getElementsByClassName('jm-image-item');
	if (togglelink.innerHTML === 'Sulje kategoria') {
		for (var i = 0; i < extrainfos.length; i++) {
			togglelink.innerHTML = 'Avaa erittely ja muokkaa';
			console.log(extrainfos, extrainfos);
			extrainfos[i].style.display = 'none';
		}
	} else {
		for (var i = 0; i < extrainfos.length; i++) {
			togglelink.innerHTML = 'Sulje kategoria';
			console.log(extrainfos, extrainfos);
			extrainfos[i].style.display = 'flex';
		}
	}
}

// Hides floating cart when element is in viewport
var juhlamenuFooter = document.querySelector('.jm-footer');
var juhlamenuFloatingCart = document.getElementById('#juhlamenu-floating-total');
var bounding = juhlamenuFooter.getBoundingClientRect();
var isInViewport = function () {
	var bounding = juhlamenuFooter.getBoundingClientRect();
	return (
		bounding.top >= 0 &&
		bounding.left >= 0 &&
		bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
		bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
	);
};

window.addEventListener('scroll', function (event) {
	var juhlamenuFloatingCart = document.getElementById('juhlamenu-floating-total');
	if (isInViewport(juhlamenuFooter)) {
		juhlamenuFloatingCart.style.display = 'none';
	} else {
		juhlamenuFloatingCart.style.display = 'block';
	}
});
